import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
// import { useUser } from "./UserContext"; // Temporarily disabled
import { useApi } from "../utils/Api";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

// const CART_EXPIRY_MS = 7 * 24 * 60 * 60 * 1000; 

export const CartProvider = ({ children }) => {
  // const { user, loading: userLoading } = useUser(); // Temporarily disabled
  const { apiFetch } = useApi();
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- Load cart from localStorage / sessionStorage ---
  // const loadCartItems = (userId) => {
  //   if (!userId) return [];
  //   const savedCart = localStorage.getItem(`cartItems_${userId}`);
  //   if (!savedCart) return [];
  //   return [];
  // };

  // --- Save cart ---
  const saveCart = useCallback(
    (items) => {
      // if (user?.id) {
      //   localStorage.setItem(
      //     `cartItems_${user.id}`,
      //     JSON.stringify({ items, savedAt: Date.now() }),
      //   );
      // } else {
        sessionStorage.setItem("guestCart", JSON.stringify(items));
      // }
    },
    // [user?.id],
    [],
  );

  // --- Calculate total price for a cart item ---
  const calculateTotalPrice = (cartItem) => {
    let totalPrice = parseFloat(cartItem.item?.price || 0);

    if (cartItem.selectedRequiredOption) {
      totalPrice += parseFloat(cartItem.selectedRequiredOption.price || 0);
    }

    if (cartItem.selectedOptionalOptions?.length) {
      cartItem.selectedOptionalOptions.forEach(
        (opt) =>
          (totalPrice +=
            parseFloat(opt.option_price || 0) * (opt.quantity || 1)),
      );
    }

    ["swallowOptions", "proteins"].forEach((optType) => {
      cartItem.item?.[optType]?.forEach(
        (opt) =>
          (totalPrice +=
            parseFloat(opt.option_price || 0) * (opt.quantity || 1)),
      );
    });

    return totalPrice * cartItem.quantity;
  };

  // --- Add item to cart ---
  const addToCart = (item) => {
    if (!item || !item.item?.id) return;

    const newCartItem = {
      ...item,
      quantity: item.quantity || 1,
      selectedRequiredOption: item.selectedRequiredOption
        ? { ...item.selectedRequiredOption }
        : null,
      selectedOptionalOptions: (item.selectedOptionalOptions || []).map(
        (opt) => ({ ...opt }),
      ),
      key: `${item.item.id}-${Date.now()}-${Math.random()}`,
      totalPrice: calculateTotalPrice(item),
    };

    setCartItems((prevItems) => {
      const updatedCart = [...prevItems, newCartItem];
      saveCart(updatedCart);
      return updatedCart;
    });
  };

  // --- Update quantity of a cart item ---
  const updateCartItemQuantity = (cartItemKey, newQuantity) => {
    setCartItems((prevItems) => {
      const updatedCart = prevItems.map((cartItem) =>
        cartItem.key === cartItemKey
          ? {
              ...cartItem,
              quantity: newQuantity,
              totalPrice: calculateTotalPrice({
                ...cartItem,
                quantity: newQuantity,
              }),
            }
          : cartItem,
      );
      saveCart(updatedCart);
      return updatedCart;
    });
  };

  // --- Update optional option quantity ---
  const updateOptionalOptionQuantity = (itemId, optionId, newQuantity) => {
    setCartItems((prevItems) => {
      const updatedCart = prevItems.map((cartItem) => {
        if (cartItem.item.id === itemId) {
          const updatedOptions = cartItem.selectedOptionalOptions.map((opt) =>
            opt.id === optionId ? { ...opt, quantity: newQuantity } : opt,
          );
          return {
            ...cartItem,
            selectedOptionalOptions: updatedOptions,
            totalPrice: calculateTotalPrice({
              ...cartItem,
              selectedOptionalOptions: updatedOptions,
            }),
          };
        }
        return cartItem;
      });
      saveCart(updatedCart);
      return updatedCart;
    });
  };

  // --- Remove item from cart ---
  const removeItemFromCart = (cartItemKey) => {
    setCartItems((prevItems) => {
      const updatedCart = prevItems.filter((item) => item.key !== cartItemKey);
      saveCart(updatedCart);
      return updatedCart;
    });
  };

  // --- Clear cart ---
  const clearCart = () => {
    setCartItems([]);
    // if (user?.id) localStorage.removeItem(`cartItems_${user.id}`);
    // else
    sessionStorage.removeItem("guestCart");
  };

  // --- Merge guest cart on login ---
  useEffect(() => {
    // if (userLoading) return;

    setLoading(true);

    // if (user?.id) {
    //   const userCart = loadCartItems(user.id);
    //   const guestCart = JSON.parse(sessionStorage.getItem("guestCart")) || [];

    //   const mergedCart = [...userCart, ...guestCart];

    //   setCartItems(mergedCart);
    //   saveCart(mergedCart);
    //   sessionStorage.removeItem("guestCart");
    // } else {
      const guestCart = JSON.parse(sessionStorage.getItem("guestCart")) || [];
      setCartItems(guestCart);
    // }

    setLoading(false);
  // }, [user?.id, userLoading, saveCart]);
  }, [saveCart]);

  // --- Populate cart from reorder (with latest prices) ---
  const populateCartFromReorder = async (order) => {
    if (!order?.items?.length) return [];

    clearCart();

    try {
      const latestData = await Promise.all(
        order.items.map((item) =>
          apiFetch("get-menu-item", { item_id: item.item_id }),
        ),
      );

      const newItems = order.items
        .map((item, index) => {
          const data = latestData[index];
          if (!data || data.status !== "success") return null;

          const latestItem = data.item;

          const selectedRequiredOption = item.required_option_id
            ? (() => {
                const latestOpt = latestItem.required_options?.find(
                  (o) => o.id === item.required_option_id,
                );
                return {
                  id: item.required_option_id,
                  name: latestOpt?.option_name || item.required_option_name,
                  price: Number(
                    latestOpt?.option_price ?? item.required_option_price ?? 0,
                  ),
                };
              })()
            : null;

          const selectedOptionalOptions = (item.selectedOptionalOptions || []).map(
            (opt) => {
              const latestOpt = latestItem.optional_options?.find(
                (o) => o.id === opt.id,
              );
              return {
                id: opt.id,
                name: latestOpt?.option_name || opt.option_name || opt.name,
                price: Number(latestOpt?.option_price ?? 0),
                quantity: opt.quantity,
              };
            },
          );

          const totalPrice =
            (latestItem.price +
              (selectedRequiredOption?.price || 0) +
              (selectedOptionalOptions?.reduce(
                (sum, o) => sum + o.price * o.quantity,
                0,
              ) || 0)) *
            (item.quantity || 1);

          return {
            key: `${item.item_id}-${Date.now()}-${Math.random()}`,
            quantity: item.quantity,
            item: {
              id: item.item_id,
              item_name: latestItem.item_name,
              base_price: Number(latestItem.price ?? item.base_price ?? 0),
              category_id: latestItem.category_id,
            },
            selectedRequiredOption: selectedRequiredOption
              ? {
                  ...selectedRequiredOption,
                  option_name: selectedRequiredOption.name,
                }
              : null,
            selectedOptionalOptions: selectedOptionalOptions.map((o) => ({
              ...o,
              option_name: o.name,
            })),
            totalPrice,
          };
        })
        .filter(Boolean);

      setCartItems(newItems);
      saveCart(newItems);

      return newItems;
    } catch (err) {
      console.error("Failed to reorder items:", err);
      return [];
    }
  };

  const updateCartItem = (key, updatedItem) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.key === key
          ? { ...updatedItem, totalPrice: calculateTotalPrice(updatedItem) }
          : item,
      ),
    );
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeItemFromCart,
        updateCartItemQuantity,
        updateOptionalOptionQuantity,
        clearCart,
        populateCartFromReorder,
        updateCartItem,
        loading,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
